import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'
import store from './store'

NProgress.configure({showSpinner: false}); // NProgress Configuration

router.beforeEach(async (to, from, next) => {  
  let target = document.querySelector('body')
  target.classList.remove('no-scroll')
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  // document.title = getPageTitle(to.meta.title);

  store.commit("setMenuTitle", to.meta.title);

  console.log('to.meta.title', to.meta.title)
  //...
  next();
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
});



// WEBPACK FOOTER //
// ./src/permission.js